import { makeFilterItemOptionsFromSuggestionField } from "components/Filters/helpers";
import { FilterItem, FiltersItemsOptionsMap } from "components/Filters/types";
import {
  SearchQueryOrderDirection,
  SearchSuggestionsField,
  SearchSuggestionsFieldType,
} from "types/generated";

import { getIntegrationById, integrationIds } from "./registry";
import { IntegrationType } from "./types";

const INTEGRATIONS_STORAGE_KEY = "integrations";
export const FILTER_TYPE = `${INTEGRATIONS_STORAGE_KEY}-filters`;
export const FILTERS_ORDER_SETTINGS_KEY = `${INTEGRATIONS_STORAGE_KEY}-filters-order`;
export const INTEGRATIONS_CALLOUT_STORAGE_KEY = `${INTEGRATIONS_STORAGE_KEY}-callout`;

export const INTEGRATIONS_FILTERS_DICTIONARY: Record<IntegrationType, string> = {
  source_code: "Source code",
  cloud: "Cloud",
  communication: "Communication",
  observability: "Observability",
  idp: "Identity Providers",
  api: "APIs",
};

export const FILTER_VARIABLES = {
  filterType: FILTER_TYPE,
  initialSortDirection: SearchQueryOrderDirection.Asc,
  initialSortOption: "",
};

const INTEGRATION_FILTER_TYPE: SearchSuggestionsField = {
  filterable: true,
  name: "type",
  orderable: false,
  possibleValuesEnum: {
    counts: new Array(IntegrationType.length).fill(0),
    values: IntegrationType,
  },
  possibleValuesBoolean: null,
  possibleValuesString: null,
  possibleValuesHierarchy: null,
  possibleValuesTime: null,
  type: SearchSuggestionsFieldType.Enum,
};

const FILTER_KEY = "Categories";

export const INTEGRATIONS_FILTERS: FilterItem[] = [
  {
    key: FILTER_KEY,
    filterName: FILTER_KEY,
    type: SearchSuggestionsFieldType.Enum,
  },
];

export const INTEGRATIONS_FILTERS_OPTIONS_MAP: FiltersItemsOptionsMap = (() => {
  const filtersItemsOptionsMap: FiltersItemsOptionsMap = new Map([]);

  // We don't have an API for SearchSuggestionsField, so we mock the object in the FE.
  const cloneFiltersItem: SearchSuggestionsField = JSON.parse(
    JSON.stringify(INTEGRATION_FILTER_TYPE)
  );
  integrationIds.forEach((id) => {
    const integration = getIntegrationById(id);
    if (!integration) return;
    if (!cloneFiltersItem.possibleValuesEnum) return;

    const ind = cloneFiltersItem.possibleValuesEnum.values.indexOf(integration.type);
    cloneFiltersItem.possibleValuesEnum.counts[ind] += 1;
  });
  const options = makeFilterItemOptionsFromSuggestionField(cloneFiltersItem);

  if (options) {
    const mappedFilterOptions = options.map((option) => ({
      ...option,
      value: INTEGRATIONS_FILTERS_DICTIONARY[option.value as IntegrationType] ?? option.value,
    }));
    filtersItemsOptionsMap.set(FILTER_KEY, mappedFilterOptions);
  }

  return filtersItemsOptionsMap;
})();
